import React, { useEffect, useRef, useState } from "react";
import style from "./style.module.css";
import { images } from "../../assets/images";
import { useNavigate } from "react-router-dom";
const LoginScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);
  const [isTenant, setIsTenant] = useState(false);
  const inputHeaderRef = useRef();
  const inputRef = useRef();
  const navigate = useNavigate();
  const switchLoginScreen = () => {
    setIsTenant((prev) => !prev);
    const rightContainer = document.querySelector(`.${style.rightContainer}`);
    rightContainer.style.height = 0;
    rightContainer.style.overflow = "hidden";
    rightContainer.classList.remove(`${style.rightContainer}`);
    setTimeout(() => {
      rightContainer.classList.add(`${style.rightContainer}`);
    }, 0);
  };

  const toggleInputHeaderText = (event) => {
    if (
      event.target === inputRef.current ||
      event.target.value === "continue"
    ) {
      inputHeaderRef.current.style.display = "block";
      inputHeaderRef.current.innerText = "Enter your phone number";
      inputHeaderRef.current.style.color = "Black";
      inputRef.current.placeholder = "";
    } else {
      inputHeaderRef.current.style.display = "none";
      inputRef.current.placeholder = "Enter your phone number";
      inputRef.current.style.border = "1px solid #cccccc";
    }
  };

  // const pattern = new RegExp(/^\d{1,10}$/);
  // const pattern = new RegExp(/^\d{10,}$/);
  const pattern = new RegExp(
    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  );
  const sumbitHandler = (e) => {
    e.preventDefault();
    toggleInputHeaderText(e);
    if (!pattern.test(inputRef.current.value)) {
      inputHeaderRef.current.style.display = "block";
      inputHeaderRef.current.innerText = "Enter Valid Phone Number";
      inputHeaderRef.current.style.color = "Red";
      inputRef.current.style.border = "1px solid Red";
      // console.log(e.target);
      // console.log(e.currentTarget);
    } else {
    }
  };

  const buttonEable = (e) => {
    if (pattern.test(inputRef.current.value)) {
      e.target.style.color = "white";
      e.target.style.backgroundColor = "blue";
    }
  };

  return (
    <div className={style.main} onClick={(e) => toggleInputHeaderText(e)}>
      <div className={style.leftSide}>
        <div className={style.logo} onClick={() => navigate("/")}>
          <img height={24} src={images.logo} alt="logo" />
        </div>
        <div className={style.leftContainer}>
          <div className={style.headline}>Welcome Onboard !</div>
          <div className={style.paragraph}>
            A unique PropTech Solution for property businesses to streamline
            their Operations, Finance and Management.
          </div>
          <div>
            {" "}
            <img
              className={style.profileIcon}
              src={images.groupProfileIcon}
              alt="profile icon"
            />
          </div>
          <div style={{ fontWeight: 300 }}>
            On the way to connect thousands of businesses.
          </div>
        </div>
      </div>
      <div className={style.rightSide}>
        <div className={style.rightContainer}>
          <div
            className={style.switchLoginPage}
            onClick={(e) => switchLoginScreen(e.target.innerText)}
          >
            {isTenant ? "Login As Tenant" : "Landlord Login"}
          </div>
          <div className={style.pageName}>
            {!isTenant ? "Login As Tenant" : "Landlord Login"}
          </div>
          <label htmlFor="phoneNumber" className={style.label}>
            Enter your phone number
          </label>
          <div className={style.otp}>
            An OTP (One time password) will be sent on this number
          </div>
          <form onSubmit={(e) => sumbitHandler(e)}>
            <div className={style.inputContainer}>
              <input
                id="phoneNumber"
                className={style.inputField}
                type="tel"
                placeholder="Enter your phone number"
                ref={inputRef}
              />
              <div ref={inputHeaderRef} className={style.inputHeader}>
                Enter your phone number
              </div>
            </div>
            <input
              type="submit"
              value="Continue"
              className={style.button}
              onClick={(e) => buttonEable(e)}
            />
          </form>
          <div className={style.Tc}>
            By continuing, I agree to the{" "}
            <span className={style.hiLight}>terms and conditions </span>and{" "}
            <span className={style.hiLight}>privacy policy </span>of Avasify.
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
